/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react';
import {
  Paper, Box, Typography, Grid, List, Drawer, IconButton,
} from '@mui/material';
import {
  Dashboard, Person, Store, ShoppingCart, ListAlt, MenuBook,
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import mainListItems from '../listItems/listItems';

interface _MobileDrawer {
    open: boolean;
    close: any;
}
export default function MobileDrawer({ open, close }: _MobileDrawer) {
  const location = useLocation();
  useEffect(() => {
    close();
  }, [location]);
  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={close}
      anchor="top"
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        zIndex: 9999999,
        display: { xs: 'block', sm: 'none' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: '100%',
          height: 100,
          backgroundColor: '#4c5c68',
          color: 'white',
        },
      }}
    >
      <Box sx={{
        display: 'flex !important',
        alignContent: 'space-between !important',
        justifyContent: 'space-around !important',
      }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          sx={{ marginRight: '25px !important', marginLeft: '10px !important' }}
          onClick={() => close()}
          edge="start"
        >
          <CancelOutlinedIcon />
        </IconButton>
        <List sx={{ margin: '0px', padding: 0 }}>{mainListItems('white')}</List>
      </Box>
    </Drawer>
  );
}
